import { config } from "../constants";
import axios from "../utils/axios";
import { toast } from "react-toastify";

export const loginService = async (google_code) => {
  return await axios.post(`${config.url.TAPS_URL}/api/taps/google_oauth`, {
    google_code,
  });
};

export const fetchCustomerParametersService = async () => {
  try {
    const response = await axios.get(
      `${config.url.WEBAPP}/api/datajolt/customer_parameters`
    );
    const { logo, timezone, customer_name } = response.data;

    if (logo) localStorage.setItem("logo", logo);
    if (timezone) localStorage.setItem("timezone", timezone);
    if (customer_name) localStorage.setItem("activeTenantId", customer_name);
    return customer_name;
  } catch (error) {}
};

// ============================================================
// SECRETS MANAGEMENT SERVICES
// ============================================================

export const getSecretsService = async () => {
  const response = await axios.get(
    `${config.url.WEBAPP}/api/datajolt/secrets`
  );
  return response.data;
};

export const createSecretService = async (data) => {
  const response = await axios.post(
    `${config.url.WEBAPP}/api/datajolt/secrets`,
    data
  );
  return response.data;
};

export const updateSecretService = async (id, data) => {
  const response = await axios.put(
    `${config.url.WEBAPP}/api/datajolt/secrets/${id}`,
    data
  );
  return response.data;
};

export const deleteSecretService = async (id) => {
  const response = await axios.delete(
    `${config.url.WEBAPP}/api/datajolt/secrets/${id}`
  );
  return response.data;
};
